// services/autorizaciones.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutorizacionesRequest } from '../../models/autorizaciones/AutorizacionesRequest';
import { GeneralResponse } from '../../models/autorizaciones/GeneralResponse';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { AutorizacionItem } from '../../models/autorizaciones/AutorizacionItem';
import { AsesorPoblacion } from '../../models/asesorPoblacion';

@Injectable({
    providedIn: 'root'
})
export class AutorizacionesService {

    private baseUrl = `${ENV.HOST}${URL_MAP.API.AUTORIZACIONES}`;

    constructor(private http: HttpClient) { }

    consultarAutorizaciones(
        request: AutorizacionesRequest
    ): Observable<GeneralResponse<AutorizacionItem[]>> {

        const headers = new HttpHeaders({
            'x-skip-tracking': 'true'
        });

        return this.http.post<GeneralResponse<AutorizacionItem[]>>(
            `${this.baseUrl}/gestionautorizaciones`,
            request
        );
    }

    reenviarSoportes(request: any) {
        return this.http.post<any>(
            `${this.baseUrl}/reenviarsoportes`,
            request
        );
    }

    getBitacoraSolicitud(request: any) {
        return this.http.post<any>(
            `${this.baseUrl}/gestion`,
            request,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    getAsesorPoblacion(request: any) {
        return this.http.post<AsesorPoblacion>(
            `${this.baseUrl}/asesor`,
            request
        );
    }
}